jQuery(function ($) {
	lazy_preload();
	lazy_load(jQuery(window).scrollTop());

	$(window).on('scroll', function () {
		lazy_load(jQuery(window).scrollTop());
	});

	$('body').on('scroll', function () {
		lazy_load(jQuery('body').scrollTop());
	});


	// Переход на другую страницу
	$(document).on('click', "a:not([href^='#']):not([href^='tel']):not([href^='mailto']):not([target^='_blank']):not(.js-ajax-modal):not([data-fancybox])", function (e) {
		if (e.ctrlKey) {
			return true;
		}

		if ($(this).hasClass('js-no-show-loader')) {
			return true;
		}

		let href = $(this).attr('href'),
			tl = gsap.timeline();

		if (href === '#' || href === '' || href === undefined) {
			return false;
		}

		bodyLock();
		$('#preloader-progress-val').css('width', 0);

		tl.to($('.header__logo, #window-scroll-nav'), {
			x: -50,
			opacity: 0,
			duration: .3
		});

		tl.to($('.header-menu, .order-fixed-btn,.cookie-popup-wrap'), {
			x: 50,
			opacity: 0,
			duration: .3
		}, '<');

		tl.to($('.wrapper-line'), {
			width: '200%',
			opacity: 0,
			duration: 1
		}, "<+0.1");

		tl.to($('.preloader'), {y: '0', duration: .4}, '>-0.8');

		setTimeout(function () {
			document.location.href = href;
		}, 900);


		setTimeout(function () {
			finish_load();
		}, 1400);

		setTimeout(function () {
			tl.to($('.header__logo, #window-scroll-nav'), {
				x: 0,
				opacity: 1,
				duration: .3
			});

			tl.to($('.header-menu, .order-fixed-btn,.cookie-popup-wrap'), {
				x: 0,
				opacity: 1,
				duration: .3
			}, '<');

			tl.to($('.wrapper-line'), {
				width: '100%',
				opacity: 1,
				duration: 1
			}, "<+0.1");

			tl.to($('.preloader'), {y: '-100%', duration: .4}, '>-0.8');
		}, 2000);


		return false;

	});

});

var preload_counter = 0;

function lazy_preload() {
	var load = jQuery('.js-lazy-load.preload');

	if (load.length === 0) {
		gsap.to($('#preloader-progress-val'), {width: '100%'});

		finish_load();
	}

	load.each(function (key) {
			load_img($(this), true);
		}
	);
}

function lazy_load(scroll) {
	var load = jQuery('.js-lazy-load:not(.init):not(.preload):not(.load-image)'),
		height = jQuery(window).height(),
		offset = 200;

	load.each(function (key) {
			if (scroll + height + offset > jQuery(this).offset().top && (jQuery(this).css('display') !== 'none' || scroll !== 0)) {
				load_img($(this));
			}
		}
	);
}

function lazy_load_block(block) {
	var load = block.find('.js-lazy-load:not(.init)');

	load.each(function (key) {
			if ((jQuery(this).css('display') !== 'none')) {
				load_img($(this));
			}
		}
	);

	block.each(function () {
		load_img($(this));
	});
}

function load_img(itm, preload) {
	var bg = false;

	if (is_mobile) {
		bg = itm.attr('data-image-mobile');
	}

	if (is_retina && !bg) {
		bg = itm.attr('data-image-retina');
	}

	if (is_tablet && !bg) {
		bg = itm.attr('data-image-tablet');
	}

	if (!bg) {
		bg = itm.attr('data-image');
	}


	itm.addClass('init');

	if (bg) {
		itm.css('background-image', 'url("' + bg + '")');
		itm.addClass('load-image');

		var bgimage = new Image();
		bgimage.src = bg;

		$(bgimage).on('load error', function () {
			on_img_load(itm, preload);
		});
	} else {
		if (is_mobile) {
			bg = itm.attr('data-image-src-mobile');
		}

		if (!bg && is_retina) {
			bg = itm.attr('data-image-src-retina');
		}

		if (!bg && is_tablet) {
			bg = itm.attr('data-image-src-tablet');
		}

		if (!bg) {
			bg = itm.attr('data-image-src');
		}

		if (bg) {
			itm.attr('src', bg);

			itm.one('load error', function () {
				on_img_load(itm, preload);
			});
		} else {
			on_img_load(itm, preload);
		}
	}
}

function on_img_load(itm, preload) {
	let percent = 0;
	itm.addClass('load-image');

	if (itm.hasClass('svg')) {
		svg_init();
	}

	if (preload) {
		preload_counter++;
		let all_count = $('.js-lazy-load.preload').length,
			tl = gsap.timeline();

		percent = 100 / all_count * preload_counter;

		gsap.to($('#preloader-progress-val'), {width: percent + '%'});

		if (all_count === preload_counter) {
			finish_load();
		}
	}
}

function finish_load() {
	let tl = gsap.timeline();

	$('.preloader').addClass('finish');
	tl.delay(0.9);
	tl.to($('.preloader'), {y: '-100%'});

	let window = $('#front-window1');

	let sequence_start = $('.js-sequence-start img:first-child');

	sequence_start.addClass("active");
	$('.js-sequence-start').css({
		opacity: 0,
	});

	if (is_tablet) {

		tl.fromTo($('.header'), {
			y: 10,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 0.3,
			onStart: function () {
				sequence_play($('.js-sequence-start'));
			}
		});

		if ($('.front_page').length > 0) {
			tl.fromTo($('.js-animation-title,.head-big-title, h1'), {
				y: 10,
				opacity: 0
			}, {
				y: 0,
				opacity: 1,
				duration: 0.5,
			}, "<+0.7");
		} else {
			tl.fromTo($('.js-animation-title,.js-animation-title-tablet,.head-big-title, h1, .page-head'), {
				y: 10,
				opacity: 0
			}, {
				y: 0,
				opacity: 1,
				duration: 0.5,
			}, "<");
		}


		tl.fromTo($('.js-animation-content'), {
			y: 10,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 0.5,
		}, "<+0.3");

		if (is_tablet) {
			tl.fromTo($('.js-animation-content-tablet'), {
				y: 10,
				opacity: 0
			}, {
				y: 0,
				opacity: 1,
				duration: 0.5,
			}, "<+0.3");
		}

		tl.fromTo($('.wrapper-line'), {
			width: '200%',
			opacity: 0
		}, {
			width: '100%',
			opacity: 1,
			duration: 0.5

		}, "<-0.1");

		tl.fromTo($('.cookie-popup-wrap'), {
			y: 10,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 0.3,
		}, "<+.5");

	} else {

		gsap.to($('.header-menu, .order-fixed-btn,.cookie-popup-wrap'), {
			x: 50,
			opacity: 0,
			duration: 0.1,
		});
		gsap.to($('.order-fixed-btn__text'), {
			y: 20,
			opacity: 0,
			duration: 0.1,
		});

		if (window.length > 0) {

			tl.fromTo(window.find('.bg-video'), {scale: 1.1}, {scale: 1, duration: 1, delay: -0.4});

			tl.fromTo(window.find('.js-animation-title'), {y: 30, opacity: 0}, {
				y: 0,
				opacity: 1,
				duration: 0.6,
			});

			tl.fromTo(window.find('.js-animation-content'), {y: 30, opacity: 0}, {
				y: 0,
				opacity: 1,
				duration: 0.8,
				delay: 0.1
			}, "<");

			tl.fromTo($('.wrapper-line'), {
				width: '200%',
				opacity: 0
			}, {
				width: '100%',
				opacity: 1,
				duration: 0.6,
			}, "<-0.1");


			tl.fromTo([window.find('.to-bot-window'), $('.header__logo, #window-scroll-nav')], {
				x: -50,
				opacity: 0
			}, {
				x: 0,
				opacity: 1,
				duration: 0.4,
			}, ">-0.1");

			tl.fromTo($('.header-menu, .order-fixed-btn,.cookie-popup-wrap'), {
				x: 50,
				opacity: 0
			}, {
				x: 0,
				opacity: 1,
				duration: 0.4,
			}, '<');

			tl.to($('.order-fixed-btn__text,.to-bot-window__text'), {
				y: 0,
				opacity: 1,
				duration: 0.5,
				delay: -0.3
			});
		} else {


			tl.fromTo($('.wrapper-line'), {
				width: '200%',
				opacity: 0
			}, {
				width: '100%',
				opacity: 1,
				duration: 0.6,
				onComplete: function () {
					sequence_play($('.js-sequence-start'));
				}

			}, "<-0.1");

			tl.fromTo($('.header__logo, #window-scroll-nav'), {
				x: -50,
				opacity: 0
			}, {
				x: 0,
				opacity: 1,
				duration: 0.4,
			}, ">-0.1");

			tl.fromTo($('.header-menu, .order-fixed-btn,.cookie-popup-wrap'), {
				x: 50,
				opacity: 0
			}, {
				x: 0,
				opacity: 1,
				duration: 0.4,
			}, '<');

			tl.to($('.order-fixed-btn__text,.to-bot-window__text'), {
				y: 0,
				opacity: 1,
				duration: 0.5,
				delay: -0.3
			});
		}
	}


	setTimeout(function () {
		bodyUnLock();
	}, 500);

}

var frame_index = 0,
	sequence_timeout,
	show_gsap = false,
	sequence_block = $('.sequence-animating');

function sequence_play(block) {
	clearTimeout(sequence_timeout);
	block.addClass('sequence-animating');
	frame_index = 0;
	if (show_gsap !== false) {
		show_gsap.pause();
	}

	show_gsap = gsap.to(block, {
		opacity: 1,
		duration: 1
	})

	sequence_block = block;
	sequence_timeout = setTimeout(sequency_frame, 300, block);
}

function sequency_frame(block) {
	let imgs = block.find('img'),
		frame_count = imgs.length - 1;

	++frame_index;

	if (frame_index > frame_count) {
		frame_index = frame_count;
	}

	imgs.removeClass('active');
	imgs.eq(frame_index).addClass("active");
	if (frame_index < frame_count) {
		sequence_timeout = setTimeout(sequency_frame, 1000 / 25, block);
	}
}